export default __webpack_public_path__ + "static/media/aboutpage.bb0bb76c.png";